/**
 * Scroll Position
 *
 * Maintain the previous scroll position of elements between swaps
 * Elements must have an attribute data-scroll-x=""
 */

class ScrollPosition {
    constructor() {
        htmx.on('htmx:afterSwap', (e, htmxEvent) => {
            //let updateScrollElmsY = document.querySelectorAll('[data-scroll-y]');
            //for (const [index, item] of [...updateScrollElmsY].entries()) {
            //    item.scrollTop = item.dataset.scrollY;
            //}
            let updateScrollElmsX = document.querySelectorAll('[data-scroll-x]');
            for (const [index, item] of [...updateScrollElmsX].entries()) {
                let target = item;
                let targetId = item.dataset.scrollTarget ?? null;
                if (targetId) {
                    target = document.getElementById(targetId);
                }
                if (target) {
                    target.scrollLeft = item.dataset.scrollX;
                }
            }
        });
    }
}

export default ScrollPosition;